<template>
  <div>
    <div class="app-toolbar2">
      <el-button size="small" icon="el-icon-plus" @click="toAddByGui" type="primary">图形化建模</el-button>
      <el-button size="small" icon="el-icon-plus" @click="toAddBySql" type="primary">SQL建模</el-button>
      <el-input size="small" placeholder="请输入名称或描述中的关键字" v-model="query.keyword" clearable style="width:320px">
        <el-button slot="append" size="small" icon="el-icon-search" @click="load(1)">查询</el-button>
      </el-input>
    </div>
    <el-table :data="models" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="modelId" label="ID" width="60"></el-table-column>
      <el-table-column prop="projectName" label="所属项目" width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="systemName" label="所属系统" width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="rdbDataSourceName" label="所属数据源" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="type" label="模型类型" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'OBJECT'">单一对象</span>
          <span v-if="scope.row.type === 'LIST'">列表</span>
          <span v-if="scope.row.type === 'PAGE'">分页</span>
          <span v-if="scope.row.type === 'FIELD'">单个字段</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="模型名称"></el-table-column>
      <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="acType" label="访问控制类型" width="92">
        <template slot-scope="scope">
          <span v-if="scope.row.acType === acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="buildType" label="建模方式" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.buildType === 'GUI'">图形化建模</span>
          <span v-if="scope.row.buildType === 'SQL'">SQL建模</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" width="140"></el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">配置</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <gui-config-dialog ref="guiConfigDialog" @save="load(query.page)"></gui-config-dialog>
    <sql-config-dialog ref="sqlConfigDialog" @save="load(query.page)"></sql-config-dialog>
  </div>
</template>

<script>
import { calcPage } from '@/util'
import { acTypes } from '@/config'
import GuiConfigDialog from './GuiConfigDialog'
import SqlConfigDialog from './SqlConfigDialog'

export default {
  name: 'model-manage',
  components: {
    GuiConfigDialog,
    SqlConfigDialog
  },
  data () {
    return {
      acTypes: acTypes,
      loading: false,
      models: [],
      query: {
        page: 1,
        limit: 10,
        total: 0,
        keyword: ''
      }
    }
  },
  created () {
    this.load(1)
  },
  methods: {
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgModels?keyword=${this.query.keyword}&page=${page}&limit=${this.query.limit}`
      }).then((res) => {
        let pageData = res.data.data
        this.models = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAddByGui () {
      this.$refs.guiConfigDialog.open()
    },
    toAddBySql () {
      this.$refs.sqlConfigDialog.open()
    },
    toUpdate (row) {
      if (row.buildType === 'GUI') {
        this.$refs.guiConfigDialog.open(row)
      } else if (row.buildType === 'SQL') {
        this.$refs.sqlConfigDialog.open(row)
      }
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该页面吗?', data: row, scope: this, callback: this.doDelete })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgModels/${data.modelId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load(calcPage(this.query))
        })
      }
    }
  }
}
</script>
